<template>
  <div class="h-100">
    <DBForm table="languages" form="languages" :user="user" :options="options" :csrf="csrf" />
  </div>
</template>

<script>
import DBForm from '../components/DBForm.vue'

export default {
  name: 'EditLanguages',
  props: ['user', 'options', 'csrf'],
  data () {
    return {
    }
  },
  components: {
    DBForm
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/sites/EditLanguages.vue